/* eslint-disable import/prefer-default-export */
export var ProductCategory;
(function (ProductCategory) {
    ProductCategory["EMAIL_PROTECTION"] = "EMAIL_PROTECTION";
    ProductCategory["DATA_PROTECTION"] = "DATA_PROTECTION";
    ProductCategory["NETWORK_SECURITY"] = "NETWORK_SECURITY";
    ProductCategory["APP_CLOUD_SECURITY"] = "APP_CLOUD_SECURITY";
    ProductCategory["EMAIL_PROTECTION_PROMOTIONAL"] = "EMAIL_PROTECTION_PROMOTIONAL";
    ProductCategory["APP_CLOUD_SECURITY_PROMOTIONAL"] = "APP_CLOUD_SECURITY_PROMOTIONAL";
    ProductCategory["MISCELLANEOUS"] = "MISCELLANEOUS";
})(ProductCategory || (ProductCategory = {}));
export var ProductName;
(function (ProductName) {
    ProductName["CLOUD_ARCHIVING_SERVICE"] = "Cloud Archiving Service";
    ProductName["INCIDENT_RESPONSE"] = "Incident Response";
    ProductName["IMPERSONATION_PROTECTION"] = "Impersonation Protection";
    ProductName["SECURITY_AWARENESS_TRAINING"] = "Security Awareness Training";
    ProductName["CLOUD_TO_CLOUD_BACKUP"] = "Cloud-to-Cloud Backup";
    ProductName["DATA_INSPECTOR"] = "Data Inspector";
    ProductName["ZERO_TRUST_ACCESS_WEB_SECURITY"] = "Zero Trust Access/Web Security";
    ProductName["CONTENT_SHIELD"] = "Content Shield";
    ProductName["EMAIL_THREAT_SCANNER"] = "Email Threat Scanner";
})(ProductName || (ProductName = {}));
export var ProductDataGlobalNavigationSection;
(function (ProductDataGlobalNavigationSection) {
    ProductDataGlobalNavigationSection["TOP"] = "TOP";
    ProductDataGlobalNavigationSection["BOTTOM"] = "BOTTOM";
})(ProductDataGlobalNavigationSection || (ProductDataGlobalNavigationSection = {}));
export var FirstValueStatus;
(function (FirstValueStatus) {
    FirstValueStatus["UNKNOWN"] = "Unknown";
    FirstValueStatus["UNSUPPORTED"] = "Unsupported";
    FirstValueStatus["NOT_STARTED"] = "Not Started";
    FirstValueStatus["INCOMPLETE"] = "Incomplete";
    FirstValueStatus["COMPLETE"] = "Complete";
    FirstValueStatus["PENDING"] = "Pending"; // this means to ask again shortly
})(FirstValueStatus || (FirstValueStatus = {}));
//# sourceMappingURL=types.js.map